<template>
  <AppHeader :is_icon="false" :is_back="true" :title="''" type="none" />
  <div class="user-edit-profile" ref="scrollContainer" style="overflow-y: auto">
    <div class="page">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-6">
            <div style="padding: 0 8px">
              <div style="padding-bottom: 15px" v-show="isEntry">
                <div
                  class="progress"
                  role="progressbar"
                  aria-label="Basic example"
                  aria-valuenow="0"
                  aria-valuemin="0"
                  aria-valuemax="100"
                >
                  <div
                    class="progress-bar"
                    :style="
                      'background-color: #784ba0 !important; width: ' +
                      count +
                      '%'
                    "
                  ></div>
                </div>
              </div>
              <div
                style="
                  padding-top: 10px;
                  padding-bottom: 10px;
                  font-size: 20px;
                  font-weight: bold;
                  color: #827490;
                "
              >
                性的嗜好
              </div>
              <div
                style="
                  padding: 10px 0px 20px 0;
                  font-size: 12px;
                  font-weight: 400;
                "
              >
                自身の性的好みを振り返ってみましょう
              </div>
              <div class="item-box">
                <div style="padding-top: 5px">
                  <button
                    v-for="(item, i) in this.directional"
                    :key="i"
                    type="button"
                    style="
                      margin-right: 5px;
                      margin-bottom: 5px;
                      width: auto !important;
                      border-radius: 30px !important;
                    "
                    :class="
                      isSelectedDirectional(item)
                        ? 'btn btn-kinkyer m-plus-medium'
                        : 'btn btn-kinkyer-outline-by-color m-plus-medium'
                    "
                    @click="clickSelectedDirectional(item)"
                  >
                    {{ item }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    style="
      position: fixed;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 75px;
      padding: 5px 8px;
      background-color: #fff;
    "
  >
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6" style="height: 65px">
          <button
            type="button"
            style="width: 100%; height: 40px"
            class="btn btn-kinkyer m-plus-medium"
            @click="((isEdit = true), update())"
          >
            {{ btnName }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    v-show="isEdit"
    style="
      position: fixed;
      top: 0px;
      width: 100%;
      height: 100%;
      background-color: rgb(0 0 0 / 50%);
      margin: 0 auto;
      padding-top: 200px;
      text-align: center;
      z-index: 999;
    "
  >
    <div style="position: absolute; z-index: 9999; width: 100%">
      <VueSpinnerBars size="50" color="#fff" />
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/HeaderView.vue";
import { db } from "../../../plugins/firebase";
import { doc, updateDoc } from "firebase/firestore";
import { store, setUser } from "../../../plugins/store";

export default {
  data() {
    return {
      isEdit: false,
      isEntry: false,
      user: {},
      btnName: "",
      count: 0,
      selectedDirectional: [],
      directional: [
        "#攻めタイプ",
        "#受けタイプ",
        "#スイッチタイプ",
        "#自分の欲に忠実タイプ",
        "#なんとなく自覚",
        "#どんなタイプが探し中",
        "#性癖迷子",
        "#シチュエーション萌え",
        "#BDSM好き",
        "#緊縛好き",
        "#鞭好き",
        "#蝋燭好き",
        "#ぐりぐら好き",
        "#スパンキング好き",
        "#フェティッシュ好き",
        "#相手の反応を見るのが好き",
        "#相手が楽しそうにしてるのが好き",
        "#育成・調教が好き",
        "#粘膜接種は控えめ",
        "#同性に遊ばれたい・遊びたい",
        "#異性に遊ばれたい・遊びたい",
        "#加虐欲",
        "#被虐欲",
        "#支配・所有欲",
        "#ドミ・サブ向けSM主義",
        "#プレイのみの快楽主義",
        "#女性上位主義",
        "#精神的に屈服されたい",
        "#肉体的に負かされたい",
        "#一緒に性癖を育みたい",
        "#日常と非日常の線引きはしっかりと",
        "#プライベートは互いに大事に",
        "#甘えたい",
        "#甘やかしたい",
        "#主導権を持ちたい",
        "#相手に委ねたい",
        "#相手の欲求に応えたい",
        "#主導権は持ちたい",
        "#相手に委ねたい",
      ],
    };
  },
  async created() {
    this.count = 3.846 * 14;
    this.isEntry = this.$route.params.type != "mod";
    this.btnName = this.$route.params.type == "mod" ? "保存する" : "次へ";
    this.user = store.user;
  },
  mounted() {
    this.selectedDirectional =
      this.user.selectedDirectional == undefined
        ? []
        : this.user.selectedDirectional;
  },
  components: {
    AppHeader,
  },
  methods: {
    async update() {
      try {
        const docUpdateUsersRef = doc(db, "users", this.user.uid);

        await updateDoc(docUpdateUsersRef, {
          selectedDirectional: this.selectedDirectional,
        });

        this.user.selectedDirectional = this.selectedDirectional;

        setUser(this.user, this.user.uid);

        if (this.$route.params.type == "mod") {
          this.$router.go(-1);
        } else {
          this.$router.push("/user/edit/tag/" + this.$route.params.type);
        }
      } catch (error) {
        this.isEdit = false;
        console.error("Error :", error);

        this.$toast.show("登録時にエラーが発生しました", {
          type: "error",
          position: "bottom",
          duration: 2000,
        });
        return;
      }
    },
    isSelectedDirectional(value) {
      return this.selectedDirectional.includes(value);
    },
    clickSelectedDirectional(value) {
      if (this.isSelectedDirectional(value)) {
        const index = this.selectedDirectional.indexOf(value);
        if (index !== -1) {
          this.selectedDirectional.splice(index, 1); // 配列から削除
        }
      } else {
        this.selectedDirectional.push(value);
      }
    },
  },
};
</script>

<style scoped>
.user-edit-profile {
  animation: fadeIn 1.2s cubic-bezier(0.33, 1, 0.68, 1) 1 forwards;
  height: 100%;
}
.page {
  padding-top: 80px;
  padding-bottom: 80px;
}
.item-box {
  padding-bottom: 20px;
}
.item-title {
  font-size: 14px;
  font-weight: 600;
}
.item-subtitle {
  font-size: 12px;
  font-weight: 600;
}
.item-description {
  font-size: 12px;
  font-weight: 400;
}
</style>
